import {
  Component,
  Input,
  OnChanges,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Chart, registerables } from "chart.js";

import { ChartSpec, toChartSpec } from "./chart.adapter";

// ng2-charts needs the Chart.js controllers registered once. The app already
// did this from one dashboard component, which only worked while that chunk
// happened to be loaded; doing it here ties registration to the component that
// actually needs it.
Chart.register(...registerables);

/**
 * Drop-in replacement for <apx-chart>, rendering through ng2-charts (MIT).
 *
 * Each call site used to spread one options object across a dozen inputs
 * (`[series]="o.series" [chart]="o.chart" [xaxis]="o.xaxis" ...`); this takes
 * that same object whole, so a swap is one line per chart and the components
 * keep building their options exactly as before.
 */
@Component({
  selector: "app-chart",
  templateUrl: "./chart.component.html",
  styleUrls: ["./chart.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ChartComponent implements OnChanges {
  /** An ApexCharts-shaped options object. See chart.adapter.ts. */
  @Input() options: any;

  spec: ChartSpec | null = null;

  ngOnChanges(): void {
    this.spec = toChartSpec(this.options);
  }
}
